// components/FAQItem.tsx
import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FaqItem } from "./types";

const FAQItem: React.FC<FaqItem> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <section style={{ marginTop: "20px" }}>
      <div
        onClick={() => setIsOpen(prev => !prev)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          backgroundColor: "#f2f2f2",
          padding: "15px 20px",
        }}
      >
        <h4 className="learnmore-title" style={{ marginBottom: 0 }}>
          {question}
        </h4>
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </div>

      {isOpen && <div className="faq-answer">{answer}</div>}
    </section>
  );
};

export default FAQItem;
